module.exports = __webpack_public_path__ + "media/images/dummy_item13-96b1839a496f5a20a215c7bc49b0dfab.jpg";